{
  "nav": {
    "stats": "Tölfræði",
    "registerCatch": "Skrá afla",
    "myCatches": "Minn afli",
    "myFiskekort": "Mínar veiðileyfi",
    "myBookings": "Mínar bókanir",
    "profile": "Prófíll",
    "login": "Innskráning",
    "logout": "Útskráning",
    "admin": "Stjórnandi",
    "valdAdmin": "Vald-stjórnandi",
    "riverAdmin": "Árstjórnandi",
    "history": "Saga",
    "buyFiskekort": "Kaupa veiðileyfi",
    "registerLink": "Búa til reikning",
    "loggFiskedag": "Skrá fiskadag",
    "contact": "Hafðu samband",
    "language": "Tungumál",
    "fiskeHer": "Veiðast hér",
    "sectionFishing": "Veiði",
    "sectionExplore": "Skoða",
    "sectionAccount": "Minn reikningur",
    "sectionManagement": "Stjórnun",
    "sectionForOwners": "Fyrir eigendur",
    "sellFiskekort": "Selja veiðileyfi",
    "riverOwnersAssoc": "Félag árareigenda",
    "photoContest": "Ljósmyndasamkeppni",
    "adminPhotoContest": "Ljósmyndasamkeppni (stjórnandi)",
    "menu": "Valmynd",
    "openMenu": "Opna valmynd",
    "closeMenu": "Loka valmynd",
    "privacy": "Persónuvernd",
    "rivers": "Ár og veiðisvæði"
  },
  "stats": {
    "title": "Aflatölfræði",
    "filterYear": "Ár",
    "filterMonth": "Mánuður",
    "filterWeek": "Vika",
    "filterDay": "Dagur",
    "totalCatches": "Heildarafli",
    "totalWeight": "Heildarþyngd",
    "avgWeight": "Meðalþyngd",
    "biggestFish": "Stærsti fiskur",
    "released": "Sleppt",
    "recentCatches": "Nýlegur afli",
    "noData": "Enginn afli á völdu tímabili",
    "allRivers": "Allar ár",
    "allValds": "Öll völd",
    "viewVald": "Skoða vald →",
    "uniqueAnglers": "Veiðimenn",
    "cpue": "Afli á veiðimann",
    "registerCatchDesc": "Skráðu fiskinn sem þú veiddir með tegund, þyngd og lengd. Nafn þitt birtist ekki opinberlega sjálfgefið.",
    "startFishingDesc": "Ýttu þegar þú byrjar að veiða og á „Veiði lokið“ þegar þú ert búin/n. Við vistum aðeins tímasetningar, aldrei staðsetningu.",
    "intro": "Lakseborsen er opin <b>laxakauphöll</b> sem safnar <b>laxatölfræði</b> í rauntíma frá skráðum norskum lax- og sjóbirtingsám. Sjáðu nýjustu veiðitölur fyrir <b>{{year}}</b> — fjölda veiða, heildarþyngd, meðalþyngd og stærsta fisk á hverja á eða svæði. Farðu í <history>veiðisögu</history> til að sjá tímabil allt frá 2014."
  },
  "catch": {
    "title": "Skrá afla",
    "vald": "Vald",
    "selectVald": "Veldu vald…",
    "fishType": "Fiskategund",
    "weight": "Þyngd (kg)",
    "weightKg": "Þyngd (kg)",
    "length": "Lengd (cm)",
    "lengthCm": "Lengd (cm)",
    "date": "Dagsetning",
    "time": "Tími",
    "gear": "Veiðarfæri",
    "photo": "Mynd (valfrjálst)",
    "photoUploadFailed": "Myndahleðsla mistókst",
    "released": "Sleppt",
    "fromBoat": "Frá báti",
    "sex": "Kyn (valfrjálst)",
    "sexTypes": {
      "hann": "Karl",
      "hunn": "Kvenfiskur"
    },
    "seaLice": "Laxlús",
    "fisher": "Veiðimaður",
    "roer": "Áramaður",
    "onBehalf": {
      "question": "Fyrir hvern er þessi afli?",
      "self": "Mig sjálfan",
      "other": "Annan veiðimann",
      "fisherName": "Nafn veiðimanns",
      "fisherNamePlaceholder": "Sláðu inn nafn",
      "recent": "Nýlega notað"
    },
    "conditions": "Aðstæður við veiðar",
    "airTemp": "Loftlag",
    "precipitation": "Úrkoma",
    "windSpeed": "Vindhraði",
    "waterTemp": "Vatnshiti",
    "waterFlow": "Vatnsrennsli",
    "nveStationSource": "Heimild: {{station}}",
    "weatherPending": "Veðurgögn tiltæk eftir u.þ.b. 5 daga",
    "submit": "Skrá",
    "submitting": "Vista…",
    "success": "Afli skráður!",
    "offlineDraft": "Vistað staðbundið — sent sjálfkrafa þegar þú ert á netinu",
    "fishTypes": {
      "laks": "Lax",
      "brunørret": "Urriði",
      "sjøørret": "Sjóbirtingur",
      "pukkellaks": "Hnúðlax",
      "oppdrettslaks": "Eldislax",
      "støing": "Støing",
      "røye": "Bleikja",
      "ørret": "Sjóbirtingur"
    },
    "gearTypes": {
      "flue": "Fluga",
      "wobbler": "Kveikja",
      "spinner": "Snápur",
      "sluk": "Slóðlingur",
      "mark_orm": "Maðkur",
      "rapala": "Rapala",
      "annet": "Annað"
    },
    "errors": {
      "valdRequired": "Veldu vald",
      "weightInvalid": "Þyngd verður að vera á milli 0,1 og 100 kg",
      "lengthInvalid": "Lengd verður að vera á milli 5 og 250 cm",
      "dateRequired": "Gefðu upp dagsetningu og tíma",
      "fisherNameRequired": "Sláðu inn nafn veiðimannsins"
    },
    "fishingDayPrompt": "Veiddur í dag án afla?",
    "logFishingDay": "Skrá veiðidag",
    "logFishingDayDone": "Veiðidagur skráður ✓",
    "edit": "Breyta",
    "editTitle": "Breyta afla",
    "editSave": "Vista breytingar",
    "editSaved": "Afla uppfært!",
    "locate": {
      "button": "Nota staðsetningu mína",
      "locating": "Leita að staðsetningu…",
      "found": "Fann næsta vald: {{vald}}",
      "unsupported": "Staðsetning er ekki studd í þessum vafra",
      "denied": "Þú þarft að leyfa aðgang að staðsetningu til að nota þetta",
      "failed": "Ekki tókst að finna staðsetningu þína",
      "noneFound": "Engin nálæg vald hafa staðsetningargögn ennþá"
    },
    "photoPendingOffline": "Myndin hleðst upp sjálfkrafa þegar þú kemst aftur á netið",
    "photoChange": "Breyta mynd",
    "photoAdd": "Bæta við mynd",
    "photoPreviewAlt": "Forskoðun",
    "fishingDayOffline": "Vistað staðbundið — skráist sjálfkrafa þegar þú ert nettengd/ur",
    "showNamePublic": "Sýna nafn mitt opinberlega",
    "showNamePublicDesc": "Slökkt sjálfgefið. Aflinn telst með í tölfræðinni hvort sem er."
  },
  "bulk": {
    "title": "Skrá smáfisk (fjöldaskráning)",
    "intro": "Veiddur margur smásilungur? Skráðu alla í einu í stað þess að skrá einn og einn.",
    "count": "Fjöldi fiska",
    "countHint": "Skráir {{count}} fiska",
    "allReleased": "Allir sleppti",
    "optionalMeasurements": "Valfrjálsar mælingar (skildu eftir autt ef óþekkt)",
    "avgWeight": "Meðalþyngd (kg)",
    "avgLength": "Meðallengd (cm)",
    "lengthHint": "Venjulega undir 40 cm",
    "submit": "Skrá {{count}} fiska",
    "submitting": "Skráning…",
    "success": "{{count}} fiskar skráðir!",
    "successDetail": "Aflar hafa verið vistaðir og teljast með í tölfræðinni.",
    "registerMore": "Skrá meira",
    "backToForm": "Venjuleg skráning",
    "bulkLink": "Veiddur margur smásilungur? → Fjöldaskráning",
    "errors": {
      "countInvalid": "Fjöldi verður að vera á milli 1 og 50"
    },
    "decreaseCount": "Minnka",
    "increaseCount": "Auka"
  },
  "myCatches": {
    "title": "Minn afli",
    "empty": "Þú hefur ekki skráð neinn afla enn.",
    "registerFirst": "Skrá fyrsta afla þinn",
    "exportCsv": "Sækja aflann minn",
    "exportError": "Tókst ekki að sækja aflann"
  },
  "profile": {
    "title": "Minn prófíll",
    "displayName": "Nafn",
    "language": "Tungumál",
    "save": "Vista",
    "saved": "Vistað!",
    "security": "Öryggi",
    "passkey": "Aðgangslykill (líffræðileg innskráning)",
    "passkeyDesc": "Skráðu þig inn fljótt með fingrafaralesara, andlitsgreiningu eða öryggislykli.",
    "registerPasskey": "Skrá aðgangslykil",
    "addPasskey": "Bæta við nýjum aðgangslykli",
    "passkeyDefaultLabel": "Aðgangslykill",
    "passkeyAdded": "Bætt við {{date}}",
    "deletePasskey": "Eyða",
    "confirmDeletePasskey": "Eyða aðgangslykli \"{{label}}\"?",
    "hideNamePublic": "Sýna afla minn nafnlaust",
    "hideNamePublicDesc": "Nafnið þitt er falið á opinberri tölfræði. Aflar þínir teljast samt með.",
    "deleteAccount": "Eyða reikningi",
    "deleteAccountDesc": "Fjarlægir nafn þitt, tölvupóst og aðrar persónuupplýsingar úr prófílnum þínum. Aflar þínir eru varðveittir nafnlausir, eins og lög krefjast fyrir aflaskráningu.",
    "confirmDeleteAccount": "Ertu viss um að þú viljir eyða reikningnum þínum? Þessu er ekki hægt að afturkalla.",
    "privacy": "Persónuvernd",
    "privacyDesc": "Sæktu öll gögn sem við höfum um þig. Sjá einnig persónuverndarstefnuna (á norsku).",
    "exportData": "Sækja gögnin mín"
  },
  "common": {
    "loading": "Hleður…",
    "noResults": "Engar niðurstöður",
    "error": "Eitthvað fór úrskeiðis",
    "retry": "Reyna aftur",
    "kg": "kg",
    "cm": "cm",
    "back": "Til baka",
    "clear": "Hreinsa",
    "delete": "Eyða",
    "paymentMethods": "Við tökum við Vipps, korti (Visa/Mastercard) og MobilePay.",
    "cancel": "Hætta við",
    "save": "Vista",
    "previousMonth": "Fyrri mánuður",
    "nextMonth": "Næsti mánuður"
  },
  "auth": {
    "loginRequired": "Skráðu þig inn til að halda áfram",
    "loginForCatch": "Skráðu þig inn til að skrá afla",
    "loginForMyCatches": "Skráðu þig inn til að sjá afla þinn",
    "loginForProfile": "Skráðu þig inn til að sjá prófílinn þinn",
    "loginHint": "Þú getur skráð þig inn með Google, tölvupósttengli eða lykilorði",
    "registerHint": "Nýr notandi?",
    "registerLink": "Búa til reikning"
  },
  "admin": {
    "title": "Stjórnandi — mælaborð",
    "totalCatches": "Heildarafli",
    "catchesThisYear": "Afli á þessu ári",
    "totalFishers": "Virkir veiðimenn",
    "totalUsers": "Skráðir notendur",
    "tabCatches": "Aflar",
    "tabUsers": "Notendur",
    "dateFrom": "Frá dagsetningu",
    "dateTo": "Til dagsetningar",
    "allFishTypes": "Allar fiskategundir",
    "allReleased": "Allt (sleppt)",
    "keptOnly": "Aðeins haldið",
    "releasedOnly": "Aðeins sleppt",
    "applyFilters": "Sía",
    "resetFilters": "Endurstilla",
    "catchCount": "{{count}} aflar",
    "exportCsv": "Sækja CSV",
    "deleteSelected": "Eyða völdum ({{count}})",
    "confirmBulkDeleteCatches": "Eyða {{count}} afla? Þessu er ekki hægt að breyta.",
    "bulkDeleteDone": "{{count}} afli eyddir.",
    "selectAllOnPage": "Velja alla á síðu",
    "selectRow": "Velja röð",
    "fisher": "Veiðimaður",
    "yes": "Já",
    "no": "Nei",
    "prevPage": "Fyrri",
    "nextPage": "Næsta",
    "userName": "Nafn",
    "userEmail": "Tölvupóstur",
    "userRole": "Hlutverk",
    "userCatches": "Aflar",
    "registered": "Skráður",
    "role_fisher": "Veiðimaður",
    "role_admin": "Stjórnandi",
    "promote": "Gera stjórnanda",
    "demote": "Fjarlægja stjórnanda",
    "tabValds": "Völd",
    "valdName": "Vald",
    "valdRiver": "Á",
    "valdOwner": "Eigandi",
    "valdNoOwner": "Enginn eigandi",
    "assignOwner": "Úthluta eiganda",
    "clearOwner": "Fjarlægja eiganda",
    "searchUser": "Leita að notanda (nafn eða tölvupóstur)…",
    "searchVald": "Leita að valdi…",
    "search": "Leita",
    "select": "Velja",
    "filterRiver": "Sía eftir á",
    "allRivers": "Allar ár",
    "searchUsers": "Leita að nafni eða tölvupósti…",
    "ownedValds": "Völd",
    "selectVald": "Veldu vald…",
    "assignVald": "Úthluta valdi",
    "removeValdOwner": "Fjarlægja eignarhald",
    "role_river_admin": "Árstjórnandi",
    "promoteRiverAdmin": "Gera árstjórnanda",
    "demoteRiverAdmin": "Fjarlægja árstjórnanda",
    "selectRiver": "Veldu á…",
    "selectRiverSystem": "Veldu árkerfi…",
    "makeRiverAdmin": "Gera árstjórnanda",
    "inviteOwner": "Bjóða upp á eiganda veiðisvæðis",
    "inviteHint": "Settu inn netfang framtíðareigar veiðisvæðisins.",
    "inviteEmailPlaceholder": "Netfang eiganda",
    "sendInvite": "Senda boð",
    "inviteSentOk": "Boð sent á {{email}}",
    "inviteAssignedDirect": "{{email}} er þegar notandi og var úthlutaður eigandi",
    "pendingInvite": "Bíður eftir {{email}}",
    "edit": "Breyta",
    "riverClosed": "Tímabundið lokað",
    "riverDescription": "Lýsing",
    "riverFishingRules": "Veiðireglur",
    "riverFlags": "Staða",
    "riverMain": "Aðalá",
    "riverMunicipalities": "Sveitarfélag",
    "riverName": "Nafn",
    "riverNveId": "NVE stöðvarnúmer",
    "riverNveName": "Heiti NVE stöðvar",
    "riverRequiresDisinfection": "Krefst sótthreinsunar",
    "riverSeason": "Tímabil",
    "riverSeasonClose": "Tímabili lýkur (MM-DD)",
    "riverSeasonOpen": "Tímabil hefst (MM-DD)",
    "riverSystem": "Kerfi",
    "searchRiver": "Leita að á (nafn, sveitarfélag, kerfi)…",
    "tabRivers": "Ár"
  },
  "riverAdmin": {
    "title": "Árstjórnandi",
    "totalCatches": "Heildarafli",
    "catchesThisYear": "Afli á þessu ári",
    "allYears": "Öll ár",
    "exportCsv": "Sækja Excel",
    "exportError": "Tókst ekki að sækja Excel",
    "tabs": {
      "fangster": "Aflar",
      "valds": "Völd",
      "elver": "Ar",
      "meldinger": "Skila boð",
      "vilkar": "Skilmálar",
      "rettelser": "Leiðréttingar",
      "fisketrykk": "Veiðiálag",
      "elvekort": "Elvekort"
    },
    "rivers": {
      "title": "Vertöð og lokun",
      "hint": "Stilltu vertöðartimábila fyrir hverja á. Tímabundin lokun birtist veiðimanni.",
      "seasonOpen": "Vertöð hefst",
      "seasonClose": "Vertöð ljúklar",
      "month": "Mánuður",
      "day": "Dagur",
      "temporarilyClosed": "Tíbabundinn lokun",
      "temporarilyClosedHint": "Sýnir 'Tíbabundinn lokun' viðvörun á opinberri síðu árinnar. Veiðimenn geta enn skráð afla og keypt veiðileyfi.",
      "requiresDisinfection": "Krefst sótthreinsingar",
      "requiresDisinfectionHint": "Veiðimenn verða að staðfesta sótthreinsaaðferð við kaup á veiðileyfi",
      "save": "Vista",
      "saved": "Vistað ✓",
      "fishingRules": "Veiðireglur (texti, opinber)",
      "fishingRulesPlaceholder": "Sláðu inn reglur, takmarkanir og aðrar upplýsingar…",
      "description": "Lýsing (sýnileg opinberlega)",
      "descriptionPlaceholder": "Skrifaðu stutta lýsingu á ánni…",
      "images": "Myndir (sýndar á árssíðu)",
      "addPhoto": "+ Bæta við mynd",
      "municipalities": "Sveitarfélag",
      "municipalitiesHint": "Birtist í SEO-lýsigögnum og á árarsíðunni. Aðeins hægt að breyta af vefstjóra.",
      "municipalitiesPlaceholder": "t.d. Røyrvik, Namsskogan, Grong, Overhalla, Namsos",
      "stayGuide": "Hvernig á að gista hér (texti, birtist opinberlega)",
      "stayGuidePlaceholder": "Ráð um bestu gistingu fyrir veiðimenn: næsti bær, hvað er skynsamlegt að bóka snemma, veitingastaðir, leiga á búnaði…",
      "nearbyPlaces": "Hótel og veitingastaðir í nágrenninu",
      "placeName": "Nafn",
      "placeDistance": "Fjarlægð, t.d. „5 mín frá Formofoss“",
      "placeDescription": "Stutt lýsing",
      "addPlace": "+ Bæta við stað",
      "seasonEvents": "Hvað er á döfinni á tímabilinu (viðburðir)",
      "eventTitle": "Titill, t.d. „Dagur laxins“",
      "eventStart": "Upphafsdagsetning",
      "eventEnd": "Lokadagsetning (valfrjálst)",
      "eventDescription": "Stutt lýsing",
      "addEvent": "+ Bæta við viðburði",
      "placeLat": "Breiddargráða (valfrjálst)",
      "placeLon": "Lengdargráða (valfrjálst)",
      "placeHighlight": "Texti frá styrktaraðila (birtist sem kostað efni)",
      "placeTags": "Þjónusta",
      "placeSponsor": "Styður ána (styrktaraðili)",
      "placePick": "Mælt með? Skrifaðu hvers vegna (birtist sem „Mælt með af veiðifélaginu“)",
      "placeLogo": "Merki (valfrjálst)",
      "sponsorReport": "Skýrsla styrktaraðila",
      "sponsorReportMonth": "Mánuður",
      "sponsorReportLinks": "Smellir á tengil",
      "sponsorReportMap": "Sýna á korti",
      "sponsorReportCopy": "Afrita texta",
      "sponsorReportCopied": "Afritað",
      "sponsorReportHint": "Telur smelli á tengil styrktaraðila og „Sýna á korti“. Engar persónuupplýsingar eru geymdar.",
      "sponsorReportText": "{{name}}: í {{month}} var smellt á tengilinn þinn {{link}} sinnum og „Sýna á korti“ notað {{map}} sinnum.",
      "sub": {
        "season": "Tímabil",
        "content": "Efni",
        "nearby": "Í nágrenninu",
        "sponsors": "Styrktaraðilar"
      },
      "selectRiver": "Veldu á",
      "systemPlacesNote": "Gildir fyrir allar ár í {{system}}. Bættu stað við einu sinni og hann birtist á öllum ánum.",
      "sponsorReportEmpty": "Engir styrktaraðilar enn. Undir „Í nágrenninu“ geturðu hakað við „Styður ána (styrktaraðili)“ á skráningu. Styrktaraðilar birtast þá hér með smellum á mánuði.",
      "placeFamily": "Fyrir alla fjölskylduna (líka þá sem veiða ekki)",
      "placePhone": "Sími",
      "placeImage": "Mynd (styrktaraðili)",
      "sponsorTier_none": "Enginn styrktaraðili",
      "sponsorTier_friend": "Vinur árinnar",
      "sponsorTier_local": "Staðbundinn stuðningur",
      "sponsorTier_supporter": "Stuðningsaðili",
      "sponsorTier_partner": "Samstarfsaðili",
      "sponsorTier_main": "Aðalstyrktaraðili"
    },
    "valds": {
      "title": "Völd",
      "ownerLabel": "Eigandi",
      "noOwner": "Enginn eigandi",
      "assignOwner": "Breyta eiganda",
      "clearOwner": "Fjarlægja eiganda",
      "searchUsers": "Leita að notanda (nafn eða tölvupóstur)…"
    },
    "messaging": {
      "title": "Senda skilaboð",
      "recipients": "Viðtakendur",
      "recipientValdeiere": "Valdeigendur",
      "recipientFishers": "Veiðimenn",
      "recipientAll": "Allir",
      "subject": "Efni",
      "body": "Skilaboð",
      "send": "Senda skilaboð",
      "sending": "Sendir…",
      "sent": "Sent til {{count}} viðtakenda",
      "sentCount": "Fjöldi sent",
      "history": "Send skilaboð",
      "empty": "Engin skilaboð send enn",
      "recipientCustom": "Einstaklingar",
      "emailToggle": "Senda einnig með tölvupósti ({{count}} með tölvupóst)",
      "previewCount": "{{count}} viðtakendur",
      "noRecipients": "Engir viðtakendur fundust",
      "sendBtn": "Senda til {{count}} viðtakenda"
    }
  },
  "notifications": {
    "title": "Tilkynningar",
    "markAllRead": "Merkja allt lesið",
    "empty": "Engar tilkynningar",
    "typeMessageReceived": "Ný skilaboð",
    "typeValdOwnerAssigned": "Vald úthlutað"
  },
  "valdPage": {
    "river": "Á",
    "owner": "Eigandi",
    "noOwner": "Ekki tiltækt",
    "catchesThisYear": "Afli á þessu ári",
    "fiskekortTitle": "Veiðileyfi",
    "noFiskekort": "Engin veiðileyfi tiltæk fyrir þetta vald",
    "loginToBook": "Skráðu þig inn til að kaupa veiðileyfi",
    "buy": "Kaupa",
    "price": "Verð",
    "durationDay": "{{count}} dagur",
    "durationDays": "{{count}} dagar",
    "seasonLabel": "Tímabil",
    "unlimited": "Ótakmarkað",
    "available": "Laust",
    "remaining": "{{count}} eftir",
    "soldOut": "Uppselt",
    "seasonOpens": "Vertíð opnar {{date}}",
    "seasonEnded": "Vertíð er lokið",
    "preBook": "Fyrirbóka",
    "packagesTitle": "Pakkar",
    "noPackages": "Engir pakkar tiltækir",
    "packageIncludes": "Inniheldur",
    "combinedPrice": "Heildaverð: {{price}} kr",
    "orderPackageBtn": "Panta pakka",
    "accommodationTitle": "Gisting",
    "accommodationNoCardRequired": "Veiðileyfi ekki nauðsynlegt – allir geta bókað gistingu.",
    "noAccommodation": "Engin gistingartilboð tiltæk",
    "capacity": "{{count}} manneskja",
    "capacity_plural": "{{count}} manns",
    "perNight": "/ nótt",
    "book": "Bóka gistingu",
    "accommodationType_hytte": "Kofi",
    "accommodationType_rom": "Herbergi",
    "accommodationType_telt": "Tjaldpláss",
    "accommodationType_campingvogn": "Hjólhýsi",
    "accommodationType_annet": "Annað",
    "omOssTitle": "Um okkur",
    "contactPhone": "Sími",
    "contactEmail": "Tölvupóstur",
    "contactWebsite": "Vefsíða",
    "tilgjengelighet": "Aðgengi",
    "avstandBilvei": "Fjarlægð að vegi",
    "editVald": "Breyta svæði",
    "fishingSpotsTitle": "Veiðistaðir",
    "seePermits": "Skoða veiðileyfi"
  },
  "fiskekort": {
    "purchaseTitle": "Kaupa veiðileyfi",
    "product": "Vara",
    "vald": "Vald",
    "validFrom": "Fyrsti dagur",
    "validTo": "Gilt til",
    "price": "Verð",
    "confirm": "Staðfesta kaup",
    "submitting": "Kaupir…",
    "success": "Veiðileyfi keypt!",
    "successDescription": "Kortið er nú virkt. Þú finnur það undir Mínar veiðileyfi.",
    "viewMyCards": "Skoða mínar veiðileyfi",
    "currency": "kr",
    "paymentProcessing": "Greiðsla í vinnslu…",
    "paymentCancelled": "Greiðslu aflýst",
    "paymentCancelledDesc": "Þú getur reynt að kaupa veiðileyfi aftur.",
    "paymentPending": "Greiðsla móttekin",
    "paymentPendingDesc": "Við bíðum eftir staðfestingu frá greiðsluveitanda. Veiðileyfi þitt mun birtast undir Mínar veiðileyfi eftir staðfestingu.",
    "seasonNote": "Vertíð: {{open}} – {{close}}",
    "errorBeforeSeason": "Valin dagsetning er utan vertíðar. Vertíðin opnar {{open}}.",
    "errorAfterSeason": "Veiðileyfi nær yfir lok vertíðar ({{close}}). Vinsamlegast veldu fyrri upphafsdagsetningu.",
    "disinfectionTitle": "Sótthreinsing (nausynleg)",
    "disinfectionHint": "Þ essi á krefst þss að þú staðfesti að búnadur og/eða bátur hafi verið sótthreinsad ur í samræmi við reglur.",
    "disinfectionRequired": "Þú verður að velja sótthreinsaaðferð.",
    "disinfectionMethod": {
      "dried_2weeks": "Þurrkað í a.m.k. 2 vikur",
      "frozen": "Fryst",
      "heat_treated": "Hitameðhöndlað (a.m.k. 60 °C)",
      "chemical": "Efnafræðilega sótthreinsad"
    },
    "quantity": "Fjöldi leyfa",
    "totalPrice": "Heildarverð"
  },
  "myFiskekort": {
    "title": "Mínar veiðileyfi",
    "empty": "Þú ert ekki með nein veiðileyfi.",
    "validFrom": "Frá",
    "validTo": "Til",
    "status": "Staða",
    "status_confirmed": "Virkt",
    "status_cancelled": "Afturkallað",
    "status_pending": "Bíður",
    "vald": "Vald",
    "product": "Tegund",
    "price": "Greitt",
    "bookAgain": "Bóka aftur →",
    "showProof": "Sýna sönnun",
    "registerCatch": "Skrá afla"
  },
  "myBookings": {
    "title": "Mínar bókanir",
    "empty": "Þú ert ekki með neinar bókanir.",
    "listing": "Gisting",
    "checkIn": "Innritun",
    "checkOut": "Útritun",
    "guests": "Gestir",
    "total": "Samtals",
    "status_confirmed": "Staðfest",
    "status_cancelled": "Afturkallað",
    "status_pending": "Bíður",
    "cancelBtn": "Afturkalla póntun",
    "cancelConfirm": "Ertu viss um að þú viljir afturkalla þ essa póntun?",
    "cancelling": "Afturkallar…",
    "cancelError": "Tókst ekki að afturkalla. Reyndu aftur.",
    "refundNote": "Póntun afturkallað. Ev. endurgreiðsla þæjast manuelt innan 5 virkra daga."
  },
  "valdAdmin": {
    "title": "Vald-stjórnandi",
    "myValds": "Mín völd",
    "selectVald": "Veldu vald til að stjórna",
    "searchVald": "Leita að valdi…",
    "catchesThisYear": "Afli á þessu ári",
    "totalCatches": "Heildarafli",
    "fiskekortTitle": "Veiðileyfi",
    "addProduct": "Bæta við veiðileyfi",
    "editProduct": "Breyta",
    "deactivateProduct": "Gera óvirkt",
    "noProducts": "Engin veiðileyfi stillt enn",
    "description": "Lýsing (birtist á opinberri valdssíðu)",
    "savedDescription": "Vistað!",
    "saveDescription": "Vista lýsingu",
    "purchasesTitle": "Seldar veiðileyfi",
    "noPurchases": "Engar söluupplýsingar skráðar enn",
    "productName": "Nafn",
    "productPrice": "Verð (aurar)",
    "productDuration": "Gildistími (dagar)",
    "productSeasonStart": "Tímabil byrjar (YYYY-MM-DD)",
    "productSeasonEnd": "Tímabil endar (YYYY-MM-DD)",
    "productQuota": "Kvóti (autt = ótakmarkað)",
    "save": "Vista",
    "cancel": "Hætta við",
    "saving": "Vistar…",
    "confirmDeactivate": "Gera þessa vöru óvirka?",
    "confirmForceDeleteProduct": "Varan er með staðfest kaup. Eyða varanlega (þ.m.t. öll kaup)? Þessu er ekki hægt að breyta.",
    "purchaseFisher": "Veiðimaður",
    "purchaseProduct": "Vara",
    "purchaseValid": "Gilt",
    "purchaseStatus": "Staða",
    "purchasePaid": "Greitt",
    "backToValds": "Til baka í yfirlit valda",
    "viewPublicPage": "Sjá opinbera síðu",
    "tabFiskekort": "Veiðileyfi",
    "tabAccommodation": "Gisting",
    "tabPackages": "Pakkar",
    "tabSettings": "Stillingar",
    "tabRevenue": "Tekjur",
    "addListing": "Bæta við gistingu",
    "editListing": "Breyta",
    "deactivateListing": "Gera óvirkt",
    "activateListing": "Gera virkt",
    "managePhotos": "Myndir",
    "addPhoto": "Bæta við mynd",
    "deletePhoto": "Eyða mynd",
    "uploadingPhoto": "Hleður upp...",
    "confirmDeletePhoto": "Eyða þessari mynd?",
    "noListings": "Engin gistingartilboð bætt við enn",
    "listingName": "Nafn",
    "listingType": "Tegund",
    "listingCapacity": "Rýmdi (fjöldi gesta)",
    "listingPrice": "Verð á nótt (aurar)",
    "listingDesc": "Lýsing",
    "listingProximityNote": "Fjarlægð frá veiðistað",
    "listingProximityNotePlaceholder": "t.d. 5 mín akstur frá svæði 2",
    "listingOpenFrom": "Opið frá (MM-DD)",
    "listingOpenTo": "Opið til (MM-DD)",
    "listingMinNights": "Lágm. nætur",
    "listingMaxNights": "Hám. nætur",
    "blockedPeriods": "Lokaðar tímabil",
    "noBlockedPeriods": "Engin lokuð tímabil.",
    "addBlockedPeriod": "Bæta við lokunum",
    "blockedFrom": "Frá",
    "blockedTo": "Til",
    "blockedReason": "Ástæða (valfrjálst)",
    "blockedReasonHint": "t.d. Viðhald",
    "bookingsTitle": "Bókanir fyrir {{name}}",
    "noBookings": "Engar bókanir",
    "bookingGuest": "Gestur",
    "bookingDates": "Dagsetningar",
    "bookingStatus": "Staða",
    "bookingConfirm": "Staðfesta",
    "bookingCancel": "Hafna",
    "bookingStatus_pending": "Bíður",
    "bookingStatus_confirmed": "Staðfest",
    "bookingStatus_cancelled": "Hafnað",
    "addPackage": "Bæta við pakka",
    "editPackage": "Breyta",
    "deletePackage": "Eyða",
    "noPackages": "Engir pakkar bætt við enn",
    "packageName": "Nafn",
    "packageDesc": "Lýsing",
    "packageFiskekort": "Veiðileyfi-vara (valfrjálst)",
    "packageAccommodation": "Gisting (valfrjálst)",
    "packageCombinedPrice": "Heildaverð í aurum (valfrjálst)",
    "packageNone": "— ekkert —",
    "contactTitle": "Tengiliðaupplýsingar (Um okkur)",
    "contactName": "Nafn / stofnun",
    "contactPhone": "Sími",
    "contactEmail": "Tölvupóstur",
    "contactWebsite": "Vefsíða",
    "saveContact": "Vista tengiliðaupplýsingar",
    "fishingOptionsTitle": "Veiðimöguleikar",
    "suitableForFlyFishing": "Hentar fyrir fluguveiðar",
    "fishingFromBoat": "Veiðar úr báti í boði",
    "saveFishingOptions": "Vista veiðimöguleika",
    "seasonPicker": {
      "yearRound": "Allt árið",
      "yearRoundNote": "Tiltækt allt árið",
      "selectStart": "Smelltu til að velja upphafsdagsetningu",
      "selectEnd": "veldu lokadagsetningu"
    },
    "calendarPreview": "Sjá dagbókarforskoðun",
    "calendarPreviewHide": "Fela dagbókarforskoðun",
    "setupChecklist": {
      "title": "Komdu af stað – settu upp vald þitt",
      "step1": "Lýstu svæðinu",
      "step2": "Bæta við veiðileyfi-vöru",
      "step3": "Bæta við gistingu",
      "step4": "Búa til pakka",
      "optional": "valkvæmt",
      "packageHint": "Búðu til veiðileyfi-vöru og gistingartilboð áður en þú býrð til pakka."
    }
  },
  "history": {
    "title": "Aflaferill",
    "year": "Ár",
    "week": "Vika",
    "weekLabel": "Vika {{week}}",
    "allWeeks": "Allar vikur",
    "colTime": "Tími",
    "colFish": "Fiskategund",
    "colWeight": "Þyngd",
    "colLength": "Lengd",
    "colGear": "Veiðarfæri",
    "colVald": "Vald",
    "colFisher": "Veiðimaður",
    "colReleased": "Sleppt"
  },
  "accommodation": {
    "bookTitle": "Bóka gistingu",
    "listing": "Gisting",
    "checkIn": "Innritun",
    "checkOut": "Útritun",
    "guestCount": "Fjöldi gesta",
    "guestName": "Nafn þitt",
    "guestEmail": "Tölvupóstur",
    "guestPhone": "Sími (valfrjálst)",
    "notes": "Skilaboð til eiganda (valfrjálst)",
    "totalPrice": "Heildaverð",
    "totalNights": "{{count}} nótt",
    "totalNights_plural": "{{count}} nætur",
    "bookBtn": "Senda bókunarbeiðni",
    "submitting": "Sendir…",
    "success": "Beiðni send!",
    "successDetail": "Eigandinn mun hafa samband til að staðfesta.",
    "loginRequired": "Þú verður að skrá þig inn til að bóka gistingu",
    "perNight": "/ nótt",
    "datesUnavailable": "Þessar dagsetningar eru ekki í boði, veldu aðrar dagsetningar",
    "paymentProcessing": "Meðhöndlar greiðslu…",
    "paymentConfirmed": "Greiðsla staðfest!",
    "paymentConfirmedDesc": "Bókunin þín er staðfest. Við hlökkum til að sjá þig!",
    "paymentCancelled": "Greiðsla hætt við",
    "paymentCancelledDesc": "Greiðslunni var hætt við. Þú getur reynt aftur.",
    "paymentPending": "Greiðsla í bið",
    "paymentPendingDesc": "Greiðslan er ekki staðfest enn. Athugaðu Bókanirnar mínar fljótlega.",
    "viewMyBookings": "Sjá bókanirnar mínar",
    "unavailablePeriods": "Bókaðar tímabil",
    "blockedPeriods": "Lökktuð tímabil",
    "seasonWindow": "Tímabilsið opinn {{from}} – {{to}}",
    "minNightsHint": "Lágmark {{count}} nætur",
    "maxNightsHint": "Hámark {{count}} nætur",
    "minNightsError": "Lágmark {{count}} nætur krafist",
    "maxNightsError": "Hámark {{count}} nætur leyfist",
    "outsideSeason": "Valdar dagsetíngar eru utan opins tímabils"
  },
  "fiskekortList": {
    "title": "Tiltæk veiðileyfi",
    "intro": "Veldu veiðileyfi og kauptu beint",
    "noProducts": "Engin tiltæk veiðileyfi eins og er",
    "buy": "Kaupa",
    "soldOut": "Uppselt",
    "unlimited": "Ótakmarkað",
    "remaining": "{{count}} eftir",
    "durationDay": "1 dagur",
    "durationDays": "{{count}} dagar",
    "calendarView": "Dagatal",
    "listView": "Listi",
    "noProductsDay": "Engin veiðileyfi í boði þennan dag",
    "legendAvailable": "Laus pláss",
    "legendSoldOut": "Uppselt"
  },
  "fishingDay": {
    "title": "Skrá fiskadag",
    "intro": "Skráðu að þú hafir verið að fiska í dag án üess að fanga neitt.",
    "submit": "Skrá fiskadag",
    "submitting": "Skráir…",
    "success": "Fiskadagur skráður!",
    "successCta": "Viltu skrá afla?",
    "calendarTitle": "Veiðidagar þínir",
    "noCatches": "engin afli",
    "catchCount_one": "{{count}} afli",
    "catchCount_other": "{{count}} aflir",
    "delete": "Fjarlægja",
    "confirmDelete": "Fjarlægja þennan veiðidag?"
  },
  "contact": {
    "title": "Hafðu samband",
    "intro": "Ertu með spurningar eða ksæki? Sendu okkur skilaboð og við svaram eins fórt og við getum.",
    "name": "Nafn",
    "email": "Netfang",
    "message": "Skilaboð",
    "send": "Senda skilaboð",
    "sending": "Sendir...",
    "successMessage": "Takk! Við höfum móttekið skilaboð þitt og svorum fljótlega.",
    "errorMessage": "Eitthvað fór úrsk eiði. Reyndu aftur."
  },
  "revenue": {
    "title": "Tekjur",
    "year": "Ár",
    "fiskekortTotal": "Veiðileyfi",
    "bookingsTotal": "Gisting",
    "grandTotal": "Samtals",
    "fiskekortSales": "Seldar veiðileyfi",
    "accommodationBookings": "Gistingarpóntanir",
    "noData": "Engin gögn fyrir valdað ár.",
    "exportCsv": "Sækja CSV",
    "product": "Vara",
    "date": "Dagsetning",
    "amount": "Upphæð",
    "listing": "Hlutvægi",
    "checkIn": "Innritun",
    "checkOut": "Útritun",
    "guest": "Gestur",
    "payoutStatus": "Greitt",
    "payoutDone": "Já",
    "payoutPending": "Nei"
  },
  "packageOrder": {
    "title": "Panta pakka",
    "priceBreakdown": "Verðyfirlit",
    "fiskekortPart": "Veiðileyfi",
    "accommodationPart": "Gisting",
    "combinedTotal": "Heildaverð",
    "validFrom": "Upphaf leyfis (innritun)",
    "checkIn": "Innritun",
    "checkOut": "Útritun",
    "guestCount": "Fjöldi gesta",
    "guestName": "Nafn þitt",
    "guestEmail": "Netfang",
    "guestPhone": "Símanúmer (valfrjálst)",
    "notes": "Skilaboð (valfrjálst)",
    "submitBtn": "Panta og greiða",
    "submitting": "Sendir…",
    "paymentProcessing": "Vinnur greiðslu…",
    "paymentConfirmed": "Pakki pantaður!",
    "paymentConfirmedDesc": "Veiðileyfi og gisting staðfest. Gleðilegar veiðar!",
    "paymentPending": "Greiðsla í bið",
    "paymentPendingDesc": "Greiðsla ekki staðfest ennþa. Athuгаðu Pantanir mínar bráðlega.",
    "paymentCancelled": "Greiðsla aflýst",
    "paymentCancelledDesc": "Þú getur reynt aftur.",
    "viewMyBookings": "Sjá bókanir mínar",
    "loginRequired": "Þú verður að skrá þig inn til að panta pakka"
  },
  "riverPage": {
    "notFound": "Fann ekki ána",
    "temporarilyClosed": "Tímabundið lokað",
    "requiresDisinfection": "Sótthreinsun nauðsynleg",
    "packagesSection": "Pakkar — veiðileyfi + gisting",
    "valdsSection": "Veiðisvæði og veiðileyfi",
    "accommodationSection": "Gisting",
    "viewVald": "Sjá svæði",
    "noValds": "Engin svæði skráð",
    "noProductsForVald": "Engin leyfi í boði",
    "mapSection": "Kort yfir ána",
    "fishingRulesTitle": "Veiðireglur",
    "eventsSection": "Hvað er á döfinni á tímabilinu",
    "staySection": "Gisting, matur og upplifun við {{name}}",
    "readMore": "Lesa meira",
    "placeCategory_hotel": "Hótel",
    "placeCategory_restaurant": "Veitingastaður",
    "placeCategory_camping": "Tjaldsvæði",
    "placeCategory_cabin": "Sumarhús",
    "placeCategory_shop": "Verslun",
    "placeCategory_other": "Annað",
    "filterValds": "Leita að völdum…",
    "noValdMatch": "Engin vald passa við leitina",
    "fromPrice": "frá {{price}}",
    "cardCount_one": "{{count}} veiðileyfi",
    "cardCount_other": "{{count}} veiðileyfi",
    "noCardsAvailable": "Engin veiðileyfi í boði",
    "showAllValds": "Sýna öll {{count}} völd",
    "seePermits": "Skoða veiðileyfi",
    "nearbyFilter_all": "Allt",
    "nearbyFilter_stay": "Gisting",
    "nearbyFilter_eat": "Matur",
    "nearbyFilter_shop": "Verslanir",
    "nearbyFilter_other": "Annað",
    "nearbyNear": "Næst",
    "nearbyNearNone": "Ekkert valið",
    "nearbyDistance": "{{km}} km í beinni línu frá {{vald}}",
    "nearbyBookable": "Hægt að bóka hér",
    "nearbyAd": "Kostað efni",
    "nearbyTag_fiskekort": "Selur veiðileyfi",
    "nearbyTag_tackle": "Veiðibúnaður",
    "nearbyTag_guide": "Leiðsögumaður",
    "nearbyTag_boat": "Bátaleiga",
    "nearbyTag_drying": "Þurrkherbergi",
    "nearbyTag_freezer": "Frystir",
    "nearbyTag_earlyBreakfast": "Snemmbúinn morgunverður",
    "mapLayer_valds": "Veiðisvæði",
    "mapLayer_spots": "Veiðistaðir",
    "nearbySponsor": "Styður {{river}}",
    "nearbyPick": "Mælt með af veiðifélaginu",
    "nearbyShowOnMap": "Sýna á korti",
    "sponsorsRow": "Með stuðningi frá",
    "placeCategory_attraction": "Áhugaverður staður",
    "nearbyFilter_see": "Upplifun",
    "nearbyFilter_family": "Fjölskylda",
    "nearbyFamily": "Fyrir alla fjölskylduna",
    "nearbyVisit": "Skoða vefsíðu",
    "nearbyCall": "Hringja",
    "sponsorMain": "Aðalstyrktaraðili"
  },
  "fiskekortBevis": {
    "statusActive": "Virkt — leyfið er gilt",
    "refLabel": "Tilvísun",
    "print": "Prenta / Deila",
    "catchCtaText": "Veiddirdu eitthvad? Mundu ad skra aflann thinn!",
    "catchCtaBtn": "Skrá afla"
  },
  "discovery": {
    "title": "Finndu veiðileyfi í norskum laxám",
    "intro": "Skoðaðu veiðisvæði og kauptu veiðileyfi af landeigendum sem selja gegnum Lakseborsen. Síaðu eftir á, veiðitækni eða framboði.",
    "filterRiver": "Sía eftir á",
    "allRivers": "Allar ár",
    "flyFishing": "Fluguveiðar",
    "boatFishing": "Veiðar úr báti",
    "hasFiskekort": "Veiðileyfi",
    "clearFilters": "Hreinsa síur",
    "resultCount": "{{count}} veiðisvæði",
    "noResults": "Engin veiðisvæði passa við síuna.",
    "buyFiskekort": "Kaupa leyfi",
    "seeVald": "Sjá veiðisvæði",
    "searchPlaceholder": "Leita að veiðisvæði eða á",
    "sortLabel": "Raða",
    "sortName": "Nafn (A-Ö)",
    "sortPrice": "Verð"
  },
  "bliValdeier": {
    "title": "Verðu eigandi veiðisvæðis",
    "lead": "Þér hefur borist boð um að verða eigandi veiðisvæðisins {{valdName}} á ánni {{riverName}}.",
    "vald": "Veiðisvæði",
    "river": "Á",
    "loginHint": "Skráðu þig inn með reikninginn skráðan á boðsfang til að samþykkja.",
    "loginAndAccept": "Skrá inn og samþykkja",
    "autoClaimHint": "Lýkur skráningu…",
    "claiming": "Skráir eignarétt…",
    "successTitle": "Velkomin/n sem eigandi veiðisvæðis!",
    "successDesc": "Þú ert nú skráður/skráð sem eigandi {{valdName}}.",
    "goToValdAdmin": "Fara í veiðisvæðisstjórnun",
    "notFoundTitle": "Boð fannst ekki",
    "notFoundDesc": "Tengilinn er ógildur eða útrunninn.",
    "expiredTitle": "Boð útrunnið",
    "expiredDesc": "Biddu kerfisstjórnanda um að senda nýtt boð.",
    "claimedTitle": "Þegar notað",
    "claimedDesc": "Þetta boð hefur þegar verið samþykkt.",
    "errorTitle": "Eitthvað fór úrskeiðis"
  },
  "komIGang": {
    "selectVald": "Veldu veiðisvæði",
    "chooseVald": "Veldu veiðisvæði",
    "step1Title": "Tengiliðaupplýsingar",
    "step1Desc": "Sláðu inn tengiliðaupplýsingar og lýsingu á veiðisvæðinu. Þetta birtist opinberlega.",
    "contactName": "Tengiliður",
    "contactNamePlaceholder": "Nafn eða samtök",
    "phone": "Sími",
    "email": "Netfang",
    "website": "Vefsíða",
    "description": "Lýsing",
    "descriptionPlaceholder": "Segðu frá veiðisvæðinu, veiðiaðstæðum, reglum o.fl.",
    "step2Title": "Kort og veiðiháttir",
    "step2Desc": "Settu veiðisvæðið á kortið, teiknaðu mörk og veldu veiðitækni.",
    "mapLocation": "Staðsetning á korti (smelltu til að staðsetja)",
    "polygon": "Mörk veiðisvæðis (valfrjálst)",
    "flyFishing": "Hentar fyrir fluguveiðar",
    "boatFishing": "Veiðar úr báti mögulegar",
    "step3Title": "Veiðistaðir",
    "step3Desc": "Bættu við sérstökum veiðistöðum á kortið (valfrjálst).",
    "step3Hint": "Þú getur bætt veiðistöðum við úr veiðisvæðisstjórnuninni hvenær sem er.",
    "back": "Til baka",
    "nextStep": "Næsta skref",
    "skipWizard": "Sleppa",
    "goToValdAdmin": "Fara í veiðisvæðisstjórnun"
  },
  "installPrompt": {
    "text": "Bættu Lakseborsen við heimaskjáinn fyrir hraðari aðgang",
    "iosHint": "Bættu Lakseborsen við heimaskjáinn: opnaðu deilivalmyndina í vafranum og veldu „Add to Home Screen“.",
    "install": "Bæta við",
    "dismiss": "Loka"
  },
  "textSize": {
    "label": "Textastærð",
    "normal": "Venjuleg textastærð",
    "large": "Stór textastærð",
    "xlarge": "Mjög stór textastærð"
  },
  "statsSection": {
    "title": "Tölfræði og línurit",
    "yearLabel": "Tímabil",
    "tooFewData": "Það þarf fleiri gögn til að sýna þessa tölfræði",
    "noCatchesForYear": "Engir skráðir aflar á þessu tímabili",
    "loading": "Hleð tölfræði…",
    "axisCatches": "Aflar",
    "axisAvgWeight": "Meðalþyngd (kg)",
    "axisWeek": "Vika",
    "axisHour": "Klukkustund",
    "kpi": {
      "totalCatches": "Fjöldi afla",
      "totalWeight": "Heildarþyngd",
      "avgWeight": "Meðalþyngd",
      "biggestFish": "Stærsti fiskurinn",
      "releaseRate": "Hlutfall sleppt",
      "uniqueAnglers": "Virkir veiðimenn",
      "cpue": "Afli á veiðimann",
      "fishingHours": "Veiðitímar",
      "catchesPerHour": "Afli á klukkustund",
      "anglersNow": "Veiðimenn núna"
    },
    "fishType": {
      "title": "Skipting eftir fisktegund",
      "subtitle": "Fjöldi afla eftir tegund"
    },
    "gear": {
      "title": "Hvaða veiðarfæri veiðir mest?",
      "subtitle": "Aflar eftir veiðarfæri"
    },
    "weekly": {
      "title": "Hvenær á tímabilinu er veiðin best?",
      "subtitle": "Aflar á viku"
    },
    "hour": {
      "title": "Á hvaða tíma dags bítur fiskurinn?",
      "subtitle": "Aflar eftir klukkustund"
    },
    "airTemp": {
      "title": "Lofthiti og afli",
      "subtitle": "Fjöldi afla og meðalþyngd eftir hitastigi"
    },
    "waterTemp": {
      "title": "Vatnshiti og afli",
      "subtitle": "Fjöldi afla og meðalþyngd eftir hitastigi"
    },
    "waterFlow": {
      "title": "Vatnsrennsli og afli",
      "subtitle": "Fjöldi afla og meðalþyngd eftir rennslisstigi"
    },
    "historicalHeader": "Söguleg yfirsýn",
    "yearly": {
      "title": "Aflar eftir tímabili",
      "subtitle": "Heildarfjöldi skráðra afla, ár fyrir ár"
    },
    "typical": {
      "title": "Dæmigert tímabil samanborið við í ár",
      "subtitle": "Vikulegt meðaltal byggt á {{yearCount}} fyrri tímabilum",
      "avgLabel": "Meðaltal",
      "currentLabel": "{{year}}"
    },
    "biggest": {
      "title": "Stærstu aflar frá upphafi",
      "subtitle": "Topp 10 — smelltu til að sjá aflann"
    },
    "showAllCharts": "Sýna öll línurit"
  },
  "notFound": {
    "title": "Síða fannst ekki",
    "message": "Við fundum ekki síðuna sem þú leitaðir að.",
    "backHome": "Til baka á forsíðu"
  },
  "terms": {
    "title": "Veiðiskilmálar",
    "accept": "Ég hef lesið og samþykki skilmálana",
    "mustAccept": "Þú verður að samþykkja skilmálana til að halda áfram.",
    "translationNote": "Þetta er þýðing. Ef ósamræmi er gildir norski textinn.",
    "noticeTitle": "Veiðiskilmálar fyrir vatnasvæðið",
    "noticeBody": "Veiðiskilmálar hafa verið settir fyrir þetta vatnasvæði og þú hefur ekki samþykkt þá enn. Þeir gilda hvar sem þú keyptir veiðileyfið. Þú getur samt skráð aflann þinn.",
    "readAndAccept": "Lesa og samþykkja skilmálana",
    "acceptNow": "Ég samþykki skilmálana",
    "acceptFailed": "Ekki tókst að vista samþykkið. Reyndu aftur."
  },
  "checkin": {
    "intro": "Ertu að veiða núna? Byrjaðu veiði svo árfélagið sjái hversu mikill veiðitími liggur að baki aflanum.",
    "start": "Byrja veiði núna",
    "end": "Veiði lokið",
    "active": "Þú ert að veiða við {{vald}}",
    "endFailed": "tókst ekki að ljúka",
    "pickVald": "Veldu fyrst vald hér að neðan.",
    "privacy": "Við vistum aðeins tímasetningar, ekki staðsetningu.",
    "sessions": {
      "title": "Þínar lotur",
      "intro": "Gleymdirðu að ýta á „Byrja veiði“ eða „Veiði lokið“? Bættu við eða leiðréttu lotuna hér. Tímarnir eru sjálfskráðir og þú getur bætt við lotum frá síðustu 60 dögum (að hámarki 14 klukkustundir hver).",
      "empty": "Engar lotur enn.",
      "add": "Bæta við lotu",
      "edit": "Breyta",
      "delete": "Eyða",
      "confirmDelete": "Eyða þessari lotu?",
      "vald": "Vald",
      "start": "Upphaf",
      "end": "Lok",
      "save": "Vista",
      "cancel": "Hætta við",
      "running": "Í gangi",
      "unknown": "Lengd óþekkt: leiðréttu lotuna",
      "manual": "skráð handvirkt",
      "hm": "{{h}} klst. {{m}} mín.",
      "errors": {
        "end_before_start": "Lok verða að vera á eftir upphafi.",
        "too_long": "Lota getur að hámarki verið 14 klukkustundir.",
        "in_future": "Tímasetningin má ekki vera í framtíðinni.",
        "too_old": "Þú getur aðeins bætt við lotum frá síðustu 60 dögum.",
        "overlap": "Þessi lota skarast við aðra lotu hjá þér.",
        "open_session": "Ljúktu lotunni með „Veiði lokið“ í staðinn.",
        "end_required": "Færðu inn hvenær lotunni lauk.",
        "vald_not_found": "Valdið fannst ekki.",
        "generic": "Ekki tókst að vista lotuna. Reyndu aftur."
      }
    }
  },
  "elvekort": {
    "notFound": "Elvekortið fannst ekki.",
    "voluntary": "Elvekort er valfrjálst. Þú þarft það ekki til að kaupa veiðileyfi eða skrá afla.",
    "buy": "Kaupa elvekort",
    "validPeriod": "Gilt {{from}} – {{to}}",
    "myCards": "Mín elvekort",
    "offerTitle": "Elvekort fyrir vatnasvæðið",
    "confirmedTitle": "Elvekort keypt",
    "cancelledTitle": "Greiðslan var afturkölluð",
    "processing": "Vinn úr greiðslu…",
    "pendingHint": "Greiðslan er ekki staðfest enn. Athugaðu „Mín elvekort“ eftir smástund."
  },
  "riversPage": {
    "metaTitle": "Ár og veiðisvæði – laxár í Noregi | Lakseborsen",
    "metaDescription": "Yfirlit yfir laxár og veiðisvæði með veiðileyfum, tímabili og gistingu.",
    "title": "Ár og veiðisvæði",
    "intro": "Allar ár á Lakseborsen með veiðisvæðum hverrar. Veldu á til að sjá tímabil, reglur, gistingu og veitingastaði í nágrenninu.",
    "closed": "Tímabundið lokað",
    "valds": "Veiðisvæði",
    "seeRiver": "Skoða {{river}}",
    "aboutRiver": "Um ána",
    "valdsCount": "{{count}} veiðisvæði"
  }
}
